@if(objectUrl) {
  <img class="am-avatar-img" [src]="objectUrl" [style.width.px]="size" [style.height.px]="size" alt="Account manager photo" />
} @else {
  <span class="am-avatar-initials" [style.width.px]="size" [style.height.px]="size" [style.font-size.px]="size * 0.4">
    {{ initials }}
  </span>
}
